import React, { useState } from 'react';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const closeModal = () => setActiveModal(null);
  return <>
      <footer className="bg-[#2D2A26] text-[#FAF8F5]/60 py-12 text-center text-sm" data-id="element-28">
        <div className="container mx-auto px-4" data-id="element-29">
          <div className="flex items-center justify-center gap-6 mb-6" data-id="element-30">
            <button onClick={() => setActiveModal('privacy')} className="hover:text-[#FAF8F5] transition-colors underline-offset-2 hover:underline" data-id="element-31">
              Política de Privacidad
            </button>
            <span className="text-[#FAF8F5]/30" data-id="element-32">|</span>
            <button onClick={() => setActiveModal('terms')} className="hover:text-[#FAF8F5] transition-colors underline-offset-2 hover:underline" data-id="element-33">
              Términos y Condiciones
            </button>
          </div>

          <p className="mb-4" data-id="element-34">
            &copy; {new Date().getFullYear()} Reset 7×3. Todos los derechos
            reservados.
          </p>
          <p className="max-w-2xl mx-auto text-xs leading-relaxed opacity-60" data-id="element-35">
            Descargo de responsabilidad: Este producto es informativo y
            educativo. No sustituye el consejo médico profesional, diagnóstico o
            tratamiento. Siempre busca el consejo de tu médico u otro proveedor
            de salud calificado con cualquier pregunta que puedas tener sobre
            una condición médica.
          </p>
        </div>
      </footer>

      {/* Modal Overlay */}
      {activeModal && <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={closeModal} data-id="element-36">
          <div className="bg-[#FAF8F5] rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-37">
            {/* Modal Header */}
            <div className="flex items-center justify-between p-6 border-b border-[#2D2A26]/10" data-id="element-38">
              <h2 className="font-serif text-2xl text-[#2D2A26]" data-id="element-39">
                {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
              </h2>
              <button onClick={closeModal} className="p-2 hover:bg-[#2D2A26]/5 rounded-full transition-colors" data-id="element-40">
                <X className="w-5 h-5 text-[#2D2A26]" data-id="element-41" />
              </button>
            </div>

            {/* Modal Content */}
            <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)] text-[#2D2A26]/80 text-sm leading-relaxed space-y-4" data-id="element-42">
              {activeModal === 'privacy' ? <PrivacyContent data-id="element-43" /> : <TermsContent data-id="element-44" />}
            </div>
          </div>
        </div>}
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-[#2D2A26] font-medium" data-id="element-45">
        Última actualización:{' '}
        {new Date().toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })}
      </p>

      <h3 className="font-serif text-lg text-[#2D2A26] mt-6" data-id="element-46">
        1. Información que Recopilamos
      </h3>
      <p data-id="element-47">
        Recopilamos información que nos proporcionas directamente cuando
        realizas una compra, incluyendo tu nombre y dirección de correo
        electrónico. Esta información es necesaria para procesar tu pedido y
        entregarte el producto digital.
      </p>

      <h3 className="font-serif text-lg text-[#2D2A26] mt-6" data-id="element-48">
        2. Uso de la Información
      </h3>
      <p data-id="element-49">Utilizamos la información recopilada para:</p>
      <ul className="list-disc pl-5 space-y-1" data-id="element-50">
        <li data-id="element-51">Procesar y completar tu compra</li>
        <li data-id="element-52">Enviarte el producto digital adquirido</li>
        <li data-id="element-53">Comunicarnos contigo sobre tu pedido</li>
        <li data-id="element-54">
          Enviarte información relacionada con el producto (si has dado tu
          consentimiento)
        </li>
      </ul>

      <h3 className="font-serif text-lg text-[#2D2A26] mt-6" data-id="element-55">
        3. Protección de Datos
      </h3>
      <p data-id="element-56">
        Implementamos medidas de seguridad técnicas y organizativas para
        proteger tu información personal contra acceso no autorizado,
        alteración, divulgación o destrucción.
      </p>

      <h3 className="font-serif text-lg text-[#2D2A26] mt-6" data-id="element-57">
        4. Compartir Información
      </h3>
      <p data-id="element-58">
        No vendemos, comercializamos ni transferimos tu información personal a
        terceros. Esto no incluye terceros de confianza que nos ayudan a operar
        nuestro sitio web o procesar pagos, siempre que esas partes acuerden
        mantener esta información confidencial.
      </p>

      <h3 className="font-serif text-lg text-[#2D2A26] mt-6" data-id="element-59">
        5. Tus Derechos
      </h3>
      <p data-id="element-60">
        Tienes derecho a acceder, rectificar o eliminar tu información personal.
        Para ejercer estos derechos, puedes contactarnos a través de los canales
        disponibles en nuestro sitio.
      </p>

      <h3 className="font-serif text-lg text-[#2D2A26] mt-6" data-id="element-61">6. Cookies</h3>
      <p data-id="element-62">
        Nuestro sitio puede utilizar cookies para mejorar tu experiencia. Puedes
        configurar tu navegador para rechazar cookies, aunque esto puede afectar
        algunas funcionalidades del sitio.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-[#2D2A26] font-medium" data-id="element-63">
        Última actualización:{' '}
        {new Date().toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })}
      </p>

      <h3 className="font-serif text-lg text-[#2D2A26] mt-6" data-id="element-64">
        1. Aceptación de los Términos
      </h3>
      <p data-id="element-65">
        Al acceder y utilizar este sitio web y realizar una compra, aceptas
        estar sujeto a estos Términos y Condiciones. Si no estás de acuerdo con
        alguna parte de estos términos, no debes utilizar nuestro sitio.
      </p>

      <h3 className="font-serif text-lg text-[#2D2A26] mt-6" data-id="element-66">
        2. Producto Digital
      </h3>
      <p data-id="element-67">
        El producto "Alivio de Cuello y Espalda en 14 Días" es un ebook en
        formato PDF que contiene información educativa sobre ejercicios y
        rutinas de movilidad. Este producto es solo para uso personal y no puede
        ser redistribuido, revendido o compartido.
      </p>

      <h3 className="font-serif text-lg text-[#2D2A26] mt-6" data-id="element-68">
        3. Descargo de Responsabilidad Médica
      </h3>
      <p data-id="element-69">
        Este producto es únicamente informativo y educativo. No constituye
        consejo médico profesional, diagnóstico o tratamiento. Siempre consulta
        con un profesional de la salud calificado antes de comenzar cualquier
        programa de ejercicios, especialmente si tienes condiciones médicas
        preexistentes.
      </p>
      <p className="mt-2" data-id="element-70">
        No somos responsables de lesiones o daños que puedan resultar del uso de
        la información contenida en este producto.
      </p>

      <h3 className="font-serif text-lg text-[#2D2A26] mt-6" data-id="element-71">
        4. Política de Reembolso
      </h3>
      <p data-id="element-72">
        Debido a la naturaleza digital del producto, todas las ventas son
        finales. Sin embargo, si experimentas problemas técnicos para acceder al
        producto, contáctanos y haremos todo lo posible por ayudarte.
      </p>

      <h3 className="font-serif text-lg text-[#2D2A26] mt-6" data-id="element-73">
        5. Propiedad Intelectual
      </h3>
      <p data-id="element-74">
        Todo el contenido incluido en este producto, incluyendo texto, gráficos
        e imágenes, es propiedad exclusiva de Reset 7×3 y está protegido por las
        leyes de derechos de autor.
      </p>

      <h3 className="font-serif text-lg text-[#2D2A26] mt-6" data-id="element-75">
        6. Limitación de Responsabilidad
      </h3>
      <p data-id="element-76">
        En ningún caso seremos responsables por daños directos, indirectos,
        incidentales, especiales o consecuentes que resulten del uso o la
        imposibilidad de usar este producto.
      </p>

      <h3 className="font-serif text-lg text-[#2D2A26] mt-6" data-id="element-77">
        7. Modificaciones
      </h3>
      <p data-id="element-78">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Los cambios entrarán en vigor inmediatamente después de su
        publicación en el sitio.
      </p>
    </>;
}